// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1iADY","icon":"SortAdornment_icon__27giz","up":"SortAdornment_up__1Qwja","down":"SortAdornment_down__1S9MU","active":"SortAdornment_active__21pHA"};